import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
    isGoogleAnalyticsEnabled,
    loadGoogleAnalytics,
    trackPageView,
} from '../config/googleAnalytics';

/**
 * Defers gtag load until idle, then sends GA4 page views on SPA navigations.
 * Must render inside <BrowserRouter>.
 */
const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const skipInitial = useRef(true);

    useEffect(() => {
        if (!isGoogleAnalyticsEnabled()) return;
        loadGoogleAnalytics();
    }, []);

    useEffect(() => {
        if (!isGoogleAnalyticsEnabled()) return;
        const path = `${location.pathname}${location.search}${location.hash}`;
        if (skipInitial.current) {
            skipInitial.current = false;
            return;
        }
        trackPageView(path);
    }, [location.pathname, location.search, location.hash]);

    return <>{children}</>;
};

export default AnalyticsProvider;
